import { Box, Typography } from '@mui/material';

export default function MapSection() {
  return (
    <Box sx={{
      position: 'relative',
      width: '100%',
      height: { xs: '300px', sm: '400px' },
      mt: 15
    }}>
      <Box
        component="iframe"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3486.4776876310966!2d-110.96314042674359!3d29.091575608777443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86ce843130c8ec47%3A0x780a6bbbe744ea74!2sBR%20Consultores!5e0!3m2!1ses-419!2smx!4v1747696890539!5m2!1ses-419!2smx"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        sx={{
          border: 0,
          width: '100%',
          height: '100%',
          filter: 'grayscale(100%)',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: { xs: '100%', sm: '519px' },
          height: { xs: 'auto', sm: '181px' },
          background: 'linear-gradient(0deg, rgba(59, 127, 121, 1) 0%, rgba(59, 127, 121, 0.5) 100%)',
          color: 'white',
          borderTopRightRadius: { xs: '0', sm: '80px' },
          padding: { xs: '16px', sm: '24px' },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
          border: '0.8px solid rgba(255, 255, 255, 0.2)',
          pl: { xs: '20px', sm: '60px' },
        }}
      >
        <Typography sx={{
          fontWeight: 'bold',
          fontSize: { xs: '24px', sm: '36px' },
          mb: 1
        }}>
          ENCUÉNTRANOS
        </Typography>
        <Typography sx={{
          fontWeight: 'regular',
          fontSize: { xs: '14px', sm: '16px' },
          mb: 1
        }}>
          Pacheco 19, San Benito, 83190 Hermosillo, Son.
        </Typography>
        <Typography sx={{
          fontWeight: 'regular',
          fontSize: { xs: '14px', sm: '16px' },
          mb: 1
        }}>
          <strong>Teléfono:</strong> 662 215 5639
        </Typography>
        <Typography sx={{
          fontWeight: 'regular',
          fontSize: { xs: '14px', sm: '16px' }
        }}>
          <strong>Horario:</strong> De lunes a viernes de 8:00 am a 6:30 pm
        </Typography>
      </Box>
    </Box>
  );
}